import React from 'react';
import { SecondaryButton } from '../../Common';
import { Grid, Typography, Box } from '@mui/material';
import { isDesktop } from '../../../utils';
import { containerResponsiveStyle } from './styles';

const SystemSelectionControls = ({ hasSelection, onSelectAll, onDeselectAll, disabled, bulkAction, helpText }) => (
    <Grid container sx={{ ...containerResponsiveStyle }}>
        <Grid item xs={12} mt={2}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                {!hasSelection ? (
                    <SecondaryButton
                        buttonText={"Select All"}
                        onClick={onSelectAll}
                        disabled={disabled}
                    />
                ) : (
                    <SecondaryButton
                        buttonText={isDesktop ? "Deselect All" : "Clear"}
                        onClick={onDeselectAll}
                        disabled={disabled}
                    />
                )}
                {hasSelection && bulkAction}
            </Box>
        </Grid>
        <Grid item xs={12} mt={2}>
            <Typography>{helpText}</Typography>
        </Grid>
    </Grid>
);

export default SystemSelectionControls;
